export default {
  num: 0,
  ager: 0,
  list: [],
  value: '123',
  ss: 4,
  cordk: [{
    naem: '张三',
    age: 30
  }]
}
